import React from "react";
import { RouteObject } from "react-router-dom";
import Collaborators from "./collaborators";
import { AddCollaborator } from "./routes/add-collaborator";

export const CollaboratorRoutes: RouteObject[] = [
  {
    path: '',
    children: [
      {
        path: '',
        element: <Collaborators />
      }, {
        path: 'add',
        element: <AddCollaborator />
      }
    ]
  }
]
